import React from 'react';

export interface WidgetBinaryToggleIntegerProps {
  value?: number;
  onChange: (value: number) => void;
}

// eslint-disable-next-line import/no-default-export
export default function WidgetBinaryToggleInteger(props: WidgetBinaryToggleIntegerProps) {
  const { value: initialValue = 0, onChange } = props;

  const [value, setValue] = React.useState(initialValue);

  const toggle = React.useCallback(
    (value) => {
      setValue(value);
      onChange(value);
    },
    [onChange, setValue],
  );

  return (
    <div className="btn-group btn-group-justified">
      {[1, 0].map((type) => (
        <div className="btn-group" key={type.toString()}>
          <button
            type="button"
            className={`btn btn-sm btn-default 
              ${value === type ? 'active' : ''}`}
            onClick={() => toggle(type)}
          >
            {type === 0 ? translate('no') : translate('yes')}
          </button>
        </div>
      ))}
    </div>
  );
}
